.root {
  .hint {
    margin-left: var(--theme--sizing--05x);
  }
}